(() => {

  const SELECTOR = '[data-capezio-card-slider]';


  /* =========================================================
     ATUALIZA DOTS
  ========================================================= */

  function updateDots(slider) {

    if (!slider._dots) return;

    slider._dots.forEach((dot, index) => {

      dot.classList.toggle(
        'is-active',
        index === slider._currentIndex
      );

    });

  }


  /* =========================================================
     IR PARA IMAGEM
  ========================================================= */

  function goToSlide(slider, index) {

    const track = slider._track;
    const slides = slider._slides;

    if (!track || !slides || slides.length <= 1) {
      return;
    }

    const maxIndex = slides.length - 1;


    /*
     * LOOP
     * esquerda na primeira → vai para última
     * direita na última → volta para primeira
     */

    if (index < 0) {
      index = maxIndex;
    }

    if (index > maxIndex) {
      index = 0;
    }


    slider._currentIndex = index;


    track.scrollTo({
      left: track.clientWidth * index,
      behavior: 'smooth'
    });


    updateDots(slider);

  }


  /* =========================================================
     INICIALIZA CARD
  ========================================================= */

  function initSlider(slider) {

    if (!slider) return;

    if (slider.dataset.sliderInitialized === 'true') {
      return;
    }


    const track = slider.querySelector(
      '[data-capezio-slider-track]'
    );

    const slides = Array.from(
      slider.querySelectorAll(
        '[data-capezio-slider-slide]'
      )
    );

    const prev = slider.querySelector(
      '[data-capezio-slider-prev]'
    );

    const next = slider.querySelector(
      '[data-capezio-slider-next]'
    );

    const dots = Array.from(
      slider.querySelectorAll(
        '[data-capezio-slider-dot]'
      )
    );


    if (!track || slides.length <= 1) {
      return;
    }


    slider.dataset.sliderInitialized = 'true';


    slider._track = track;
    slider._slides = slides;
    slider._dots = dots;
    slider._currentIndex = 0;


    /* =====================================================
       SETA ANTERIOR
    ===================================================== */

    prev?.addEventListener(
      'click',
      (event) => {

        event.preventDefault();
        event.stopPropagation();

        goToSlide(
          slider,
          slider._currentIndex - 1
        );

      }
    );


    /* =====================================================
       SETA PRÓXIMA
    ===================================================== */

    next?.addEventListener(
      'click',
      (event) => {

        event.preventDefault();
        event.stopPropagation();

        goToSlide(
          slider,
          slider._currentIndex + 1
        );

      }
    );


    /* =====================================================
       SWIPE / SCROLL NATIVO
    ===================================================== */

    let scrollTimeout;


    track.addEventListener(
      'scroll',
      () => {

        clearTimeout(scrollTimeout);


        scrollTimeout = setTimeout(() => {

          const width = track.clientWidth;

          if (!width) return;


          slider._currentIndex = Math.round(
            track.scrollLeft / width
          );


          slider._currentIndex = Math.max(
            0,
            Math.min(
              slider._currentIndex,
              slides.length - 1
            )
          );


          updateDots(slider);

        }, 50);

      },
      {
        passive: true
      }
    );


    updateDots(slider);

  }


  /* =========================================================
     INICIALIZA TODOS
  ========================================================= */

  function initAll(context = document) {

    context
      .querySelectorAll(SELECTOR)
      .forEach(initSlider);

  }


  /* =========================================================
     PRIMEIRO CARREGAMENTO
  ========================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initAll();

      }
    );

  } else {

    initAll();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initAll(event.target);

    }
  );


  /* =========================================================
     PRESTIGE - AJAX / FILTROS / SEÇÕES
  ========================================================= */

  const observer = new MutationObserver(
    (mutations) => {

      mutations.forEach((mutation) => {

        mutation.addedNodes.forEach((node) => {

          if (!(node instanceof HTMLElement)) {
            return;
          }


          if (node.matches?.(SELECTOR)) {

            initSlider(node);

          }


          node
            .querySelectorAll?.(SELECTOR)
            .forEach(initSlider);

        });

      });

    }
  );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();